import React from 'react'
import { useIntl } from 'react-intl'

import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import useMissionAndValuesItems from './missionAndValuesItems'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

const Grid = styled.div`
  display: grid;
  gap: ${rem(24)};

  grid-template-columns: minmax(0, 1fr);

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(auto-fit, minmax(${rem(300)}, 1fr));
  }
`

const Item = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  box-shadow: ${props => props.theme.shadow.flat.small};
  padding: ${rem(16)};
  border-radius: ${props => props.theme.borderRadius.S};
`

function WhyWorkForUs() {
  const intl = useIntl()
  const missionAndValuesItems = useMissionAndValuesItems()

  return <Pane background="neutral-six">
    <PaneBody size="xl-y md">
      <LayoutContainer>
        <Group direction="vertical" gap={24}>
          <Group direction="vertical" gap={12}>
            <Heading variant="heading3" align="center" as="h2">
              {intl.formatMessage({
                id: 'rUWzfaA7yE',
                defaultMessage: 'Our mission and values',
                description: 'Section heading for mission and values on the careers page',
              })}
            </Heading>
            <BodyText variant="large" as="p" align="center">
              {intl.formatMessage({
                id: 'dPmKFspW2j',
                defaultMessage: 'Make people happy by curating and selling the world’s best holiday experiences.',
                description: 'Mission statement on the careers page',
              })}
            </BodyText>
          </Group>
          <Grid>
            {missionAndValuesItems.map((item) =>
              <Item key={item.title}>
                <Group direction="vertical" gap={12}>
                  <Group direction="horizontal" horizontalAlign="center">{item.icon}</Group>
                  <Group direction="vertical" gap={12}>
                    <BodyText variant="large" weight="bold" align="center">{item.title}</BodyText>
                    <Group direction="vertical" gap={8}>
                      {item.text.map(t =>
                        <BodyTextBlock key={t} variant="large" startIcon={<LineCheckIcon colour="primary" />}>{t}</BodyTextBlock>,
                      )}
                    </Group>
                  </Group>
                </Group>
              </Item>,
            )}
          </Grid>
        </Group>
      </LayoutContainer>
    </PaneBody>
  </Pane>
}

export default WhyWorkForUs
